<template>
  <modal title="Enjoying your free trial?" id="enjoy-trial-modal" ref="modalWrapper" :hide-footer="true" :hide-header-close="true">
    <img src="@img/pro-badge.svg">
    <div id="content">
      <p>If you want to keep using Cloudapp Pro features, why not add your billing information now and get it out of the way.</p>
      <div id="links">
        <a class="btn btn-primary" :href="billingPath">Add billing info</a>
      </div>
      <span>It won't interrupt your free trial period, and you'll transition seamlessly at the end of your trial.</span>
    </div>
  </modal>

</template>

<script>
import { mapState } from 'vuex';
import track from '../tracking';

import Modal from '@cmp/modal.vue';

export default {
  components: { Modal },
  computed: {
    ...mapState(['currentOrganization']),
    billingPath: function(){
      const organizationId = this.currentOrganization.id;
      return organizationId ? this.$root.routes.billing_settings_organization_path(organizationId) : ""
    }
  },
  watch: {
    currentOrganization: function(organization, _){
      if(organization && !organization.attributes.billing_info && organization.attributes.trial){
        const daysLeftToShowModal = 4;

        const expiresAt = new Date(organization.attributes.trial_expires_at);
        const today = new Date();
        const difference = Math.abs(expiresAt-today);
        const daysLeft = Math.round(difference/(1000 * 3600 * 24));

        if(daysLeft <= daysLeftToShowModal && !localStorage.getItem('enjoyTrialModalShown')){
          this.$refs.modalWrapper.$refs.modal.show();
          localStorage.setItem('enjoyTrialModalShown', true)

          // Track event
          track('add_billing_modal_shown', {
            org_id: organization.id,
            personal: organization.attributes.personal,
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  img {
    width: 7rem;
    margin-bottom: 1rem;
  }

  span {
    font-size: 0.7rem;
    margin-top: 1rem;
    display: inline-block;
  }
</style>

<style lang="scss">
#enjoy-trial-modal___BV_modal_outer_ {
  .modal-header {
    border-bottom: none;
    justify-content: center;
  }

  .modal-body {
    text-align: center;
  }
}
</style>